import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

export type ProcessStatus = 'open' | 'next' | 'doneAutomatically' | 'doneManually';

@Component({
  selector: 'tps-process-status-badge',
  imports: [],
  templateUrl: './process-status-badge.component.html',
  styleUrls: ['./process-status-badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProcessStatusBadgeComponent {

  status = input.required<ProcessStatus>();
  size = input<'large' | 'small'>('large');

  backgroundColor = computed(() => {
    if (this.status() === 'next' && this.size() === 'small') {
      return 'var(--tebis-color-border-primary-default)';
    }
    return {
      'doneAutomatically': 'var(--tebis-color-signal-success-main)',
      'doneManually': 'var(--tebis-color-signal-success-main)',
      'open': 'var(--tebis-color-background-container-screen)',
      'next': 'var(--tebis-color-background-container-screen)',
    }[this.status()];
  });

  getIndividualBadgeStyle() {
    let style = 'background-color: ' + this.backgroundColor() + ';';
    if (this.status() === 'next') {
      style += 'border-color: var(--tebis-color-border-primary-default);';
    }
    if (this.status() === 'doneManually' || this.status() === 'doneAutomatically') {
      style += 'border: none;';
    }
    return style;
  }
}
